/** Router location.state key when opening a till sale with a pre-scanned product. */
export const TILL_BARCODE_NAV_STATE_KEY = "tillBarcodeProduct";

export type TillBarcodeProductLine = {
  id: string | number;
  name: string;
  type: string;
  price: number;
  category: string;
  code?: string;
  quantity: number;
  differentRL: boolean;
  goodsInId?: string;
  batchNumber?: string;
  requiresLotTracking?: boolean;
};

export function findProductByBarcode(products: any[], barcode: string) {
  const b = barcode.trim().toLowerCase();
  if (!b) return undefined;
  return products.find((p) => p.code?.toLowerCase() === b);
}

export function activeProductToDispenseLine(product: any): TillBarcodeProductLine {
  return {
    id: product.id,
    name: product.name,
    type: product.type,
    price: Number(product.salePrice ?? product.price ?? 0),
    category: product.category,
    code: product.code,
    quantity: 1,
    differentRL: false,
    goodsInId: "",
    batchNumber: "",
    requiresLotTracking: Boolean(product.requiresLotTracking),
  };
}
